import { Button } from '@mui/material'
import { FaCheckCircle, FaCheckSquare, FaCircle, FaMinus, FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa'
import ProfileHeaderSlider from '../components/Header-Slider/ProfileHeaderSlider';
import HeaderSlider from '../components/Header-Slider/HeaderSlider';
import HeaderMainNavigation from '../layout/HeaderMainNavigation';
import Footer from '../components/Footer/Footer';
import React, {useCallback, useEffect, useRef, useState} from "react";
import {Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import CommonLayout from "../layout/CommonLayout";
import BackClick from "../components/BackClick";
import SingleCartProductNew from "../components/cartelements/SingleCartProductNew";
import coupon from "../assets/images/icons/applyCouponIcon.svg";
import arrow from "../assets/images/icons/checkCouponArrow.svg";
import {useDispatch, useSelector} from "react-redux";
import {getCoupon} from "../reducer/couponSlice";
import Loader from "../components/loader/Loader";
import {apiBaseUrl} from "../config";
import {getCartInfo} from "../reducer/userCartSlice";
import {BsCart3} from "react-icons/bs";
import {RiArrowDropUpLine} from "react-icons/ri";
import {RiArrowDropDownLine} from "react-icons/ri";
import {useLocation} from "react-router-dom";
import {load} from "@cashfreepayments/cashfree-js";
import randomString from "randomstring";
import axios from "axios";
import CouponModal from "../components/CouponModal/CouponModal";
import {MdAddBox} from "react-icons/md";
import InfoDialog from "../components/dialog/InfoDialog";
import {formatDateToCustom, getDomainInfo} from "../utils/utils";
import CommonButton from "../components/CommonButton";
import {getUserInfo} from "../reducer/userInfoSlice";
import TotalPayment from "./TotalPayment";
import PaymentMethodsNew from "../components/cartelements/PaymentMethodsNew";
import AddressComponentNew from "../components/cartelements/AddressComponentNew";
import CouponComponent from "../components/cartelements/CouponComponent";
import { useUser } from "../context/userContext";
import AddAddressNew from '../components/cartelements/AddAddressNew';
import EditAddressNew from '../components/cartelements/EditAddressNew';
import { toast } from "react-toastify";
import ConfirmationDialog from '../components/dialog/ConfirmationDialog';

export default function Cart2() {

    const location = useLocation()
        const [isCartLoginRequired, setCartLoginRequired] = useState(false);
        const [isOtpVerificationRequired, setOtpVerificationRequired] = useState(false);
        const [searchParams] = useSearchParams();
        const source = searchParams?.get("source");
        const navigate = useNavigate();
        const [cartItems, setCartitems] = useState([]);
        const [isLoading, setIsLoading] = useState(false);
        const [shippingfee, setShippingfee] = useState([]);
        const [pgfee, setPgfee] = useState([]);
        const [pgfeelivestatus, setpgfeelivestatus] = useState(0);
        const [shippingfeelivestatus, setshippingfeelivestatus] = useState(0);
        const [shippingfeestatus, setshippingfeestatus] = useState([]);
        ;
        const [pgfeestatus, setpgfeestatus] = useState([]);
        ;
        const currentCoupon = useSelector((state) => state.couponControl?.coupon);
        const dispatch = useDispatch();
                const [loadingO, setLoadingO] = useState(false);
    
        const storedCartItems =
            useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
        const token = localStorage.getItem("token");
        const cartContext = localStorage.getItem("cartContext");
    
        const customerId = localStorage.getItem("customerId");
    
        const [message, setMessage] = useState(""); // State to store the incoming message
        const [isConnected, setIsConnected] = useState(false);
        const [socket, setSocket] = useState(null);
    
        const discountprice = localStorage.getItem("discountamt");
        const [addresses, setAddresses] = useState([]);
        const [defaultAddress, setDefaultAddress] = useState({});
        const [selected, setSelected] = useState(null);
        const addressList = useSelector((state) => state.address?.addressList);
        const orderDateTime =formatDateToCustom( new Date())
        const [refreshAddresses, setRefreshAddresses] = useState(false);
        const userAvaterImg = useSelector((state) => state.fetchUser?.user?.profileImg);
        const storeusername = useSelector((state) => state.fetchUser?.user?.username);
        const usermobile = localStorage.getItem("usermob");
        const storephone = useSelector((state) => state.fetchUser?.user?.phone);
        const storeemail = useSelector((state) => state.fetchUser?.user?.email);
        const SelectedEmail = localStorage.getItem("selected-email");
        const Selectedaddress = JSON.parse(localStorage.getItem("selected-address"));
        const selectedName = localStorage.getItem("selected-name");
        const storeid = localStorage.getItem("storeid");
        const [marchentId, setmarchentId] = useState();
        const [isCartItemUpdated, setIsCartItemUpdated] = useState(false);
        const [showModal, setShowModal] = useState(false);
        const [infoMessage, setInfoMessage] = useState("");
        const [mobileNumber, setMobileNumber] = useState('');
        const [error, setError] = useState('');
        const cashfreeRef = useRef(null);
    
        const { userId } = useParams();
        const { uid,isPredefinedDomain } = getDomainInfo(userId);
        const { userData, fetchUserData } = useUser();
        const userid = useSelector((state) => state.fetchUser?.user?.id);
    
    
          useEffect(() => {
            if (uid) {
             fetchUserData(uid);
            } else {
              console.error("UID is undefined, skipping fetchUserData.");
            }
          }, [uid]);
    
    
        useEffect(() => {
            if (source) {
                if ((source === "whatsapp" || source === "gmail") && token) {
                    setCartLoginRequired(false);
            if (cartItems.length > 0 && userData?.id) {
                    validateCart();
            }
                } else if (source === "whatsapp" || source === "gmail") {
                    setCartLoginRequired(true);
                }
            } else {
                // handelprocesstobuy()
          if (cartItems.length > 0 && userData?.id) {
                validateCart();
            }
    }
        }, [source, token, cartItems, userData?.id]);
    
        const validateCart = async () => {
        if (!cartItems || cartItems.length === 0) {
          return;
        }
    
            const apiUrl = `${apiBaseUrl}customer/validate-cart`;
        try {  
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({sellerId: userData?.id}),
            });
    
            if (response.ok) {
                const result = await response.json();
                if (!result.isValid) {
                    setInfoMessage(result.message);
                    setIsCartItemUpdated(true);
                    setShowModal(true);
                }
          }
        } catch (error) {
          console.error("Error validating cart:", error);
            }
        };
    
        const cartItemsHtml = cartItems
            ?.map(
                (item) => `
       <tr >
         <td style="width:100px;"><img src="${
                    item.image
                }" style="width:100px; height:100px;border:1px solid #ddd"></td>
         <td style="font-weight:500;display:flex">
           <ul style=" padding: 0; list-style: none;margin:0;display: block;">
             <li style="width:100%; text-align: left; font-weight:600;">${
                    item?.title
                }</li>
             ${
                    item?.variant?.secondVariant?.title?.value?.length > 0
                        ? `<li style="width:100%; text-align: left; font-weight:600;">${item.variant.secondVariant.title.value.split("||")[0]}</li>`
                        : ""
                }
             ${
                    item?.variant?.firstVariant?.title?.value?.length > 0
                        ? `<li style="width:100%; text-align: left; font-weight:600;">${item.variant.firstVariant.title.value.split("||")[0]}</li>`
                        : ""
                }
             <li style="width:100%; text-align: left; font-weight:600;">Quantity: ${
                    item?.quantity
                }</li>
             <li style="width:100%; text-align: left; font-weight:600;">Amount: ₹${
                    (item?.price * item?.quantity)?.toLocaleString("en-IN")
                }</li>
           </ul>
         </td>
      </tr>
      `
            )
            .join("");
    
    
        // Initialize Cashfree SDK only once
        useEffect(() => {
            const initializeCashfree = async () => {
                if (!cashfreeRef.current) {
                    try {
                        cashfreeRef.current = await load({
                            mode: process.env.REACT_APP_CASHFREE_MODE,
                        });
                    } catch (error) {
                        console.error("Error initializing Cashfree:", error);
                    }
                }
            };
            initializeCashfree();
        }, []);
    
    
        /**
         * This method is used to get payload for the order  ceations
         * @param orderId
         * @param amount
         * @returns {{amount, totalAmt: *, sellerId: string, merchantId, products: {quantity: number|number|*, productId: *, variantId: ({variantID: *}|{variantID: *})[]|*[], variantName: string}[], addressId: unknown}}
         */
        const getPayloadForCreateOrder = (orderId, amount) => {
            return {
                addressId: selected,
                amount: amount,
                totalAmt: amount,
                merchantId: orderId,
                sellerId:  userData?.id,
            };
        };
    
        /**
         * This method is used to do the error handling when payment is failed
         * @param orderNumber
         * @param orderOriginalId
         */
        const handlePaymentError = async (
            orderId,
            originalOrderId,
            errorMessage,
            amount
        ) => {
            const apiUrl = `${apiBaseUrl}customer/updatePaymentFailure`;
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({
                    originalOrderId: originalOrderId,
                    errorMessage: errorMessage,
                    orderId: orderId,
                }),
            });
    
            if (response.ok) {
    
                setLoadingO(false)
                navigate(isPredefinedDomain ? `/${uid}/payment-failed` : "/payment-failed");
    
                // sendOrderFailureMailToBuyer(orderId, amount);
                // sendOrderFailureMailToSeller(orderId, amount);
            }
            
        };

        const handlePaymentSuccess = async (
                originalOrderId,
                orderId,
                amount,
                successMessage,
                paymentType
            ) => {
                // Update order number
                try {
                    const response = await fetch(
                        `${apiBaseUrl}customer/updatePaymentSuccess`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                token,
                            },
                            body: JSON.stringify({
                                originalOrderId: originalOrderId,
                                orderNumber: orderId,
                                successMessage: successMessage,
                            }),
                        }
                    );
                    if (response.ok) {
        
        
                                    setLoadingO(false)
        
                        dispatch(getCartInfo({ cartItem: [] }));
                        setCartitems([]);
                        localStorage.removeItem("cartContext");
                        navigate(
                            isPredefinedDomain
                                ? `/${uid}/order-successful`
                                : "/order-successful",
                            {
                                state: {
                                    neworderId: orderId,
                                    paymentType: paymentType,
                                    orderDateTime,
                                    orderAmount: amount,
                                },
                            }
                        );
                        // sendOrderSuccessMailToSeller(orderId, amount);
                        // sendOrderSuccessMailToBuyer(orderId, amount);
                    }
                    else {
                                    const errorData = await response.json();
                                    const errorMessage = errorData?.error || "Something went wrong";
                                    toast.error(errorMessage);
                                }
                } catch (error) {
                    setLoadingO(false)
        
                    console.error("Error updating order number:", error);
                    
                }
            };

            const placeOrder = async (
                
                    amount = totalAmountOfProduct,
                    orderId = randomString.generate(10),
                    customerId = usermobile,
                    customerContactNumber = usermobile
                ) => {
            
            
            
                    if (!isCartItemUpdated) {
                            setLoadingO(true)
            
                        const apiUrl = `${apiBaseUrl}customer/create-order`;
                        const payload = getPayloadForCreateOrder(orderId, amount);
                        const fieldsToExclude = ["id", "userid"];
            
                        const updatedCart = cartItems.map((obj) => {
                            const newObj = {...obj};
                            fieldsToExclude.forEach((field) => delete newObj[field]);
                            return newObj;
                        });
            
                        try {
                            const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    token: token,
                                },
                                body: JSON.stringify({
                                    ...payload,
                                    payment_type: selectedPayment
                                }),
                            });
            
                            if (response.ok) {
                                const result = await response.json();
                                // console.log("Backend response:", result);
            
                                const orderOrginalId = result.order.id;
                                const newOrderId = result.order.orderId;
                                const orderSplits = result.order.order_splits;
                                // console.log("Order Splits:", orderSplits);
            
                                // Set up common order data structure for both payment methods
                                const orderData = {
                                    order_amount: amount,
                                    order_currency: "INR",
                                    order_id: orderId,
                                    seller_Id:  userData?.id,
            
                                    customer_details: {
                                        customer_id: customerId,
                                        customer_name: selectedName,
                                        customer_email: SelectedEmail,
                                        customer_phone: customerContactNumber,
                                        product_info: updatedCart,
                                    },
                                    ...(orderSplits && {order_splits: orderSplits})
                                };
            
                                // For COD orders, bypass payment gateway and place order directly
                                if (selectedPayment === 'COD') {
                                    // Handle COD order directly
                                    await handlePaymentSuccess(
                                        orderOrginalId,
                                        newOrderId,
                                        amount,
                                        "COD order placed successfully",
                                        selectedPayment
                                    );
                                    return;
                                }
            
                                // For online payment, add order_meta and proceed with Cashfree
                                const onlineOrderData = {
                                    ...orderData,
                                    order_meta: {
                                        return_url:
                                            "https://www.cashfree.com/devstudio/preview/pg/web/popupCheckout?order_id=" +
                                            orderId,
                                    },
                                };
                                
                                axios
                                    .post(apiBaseUrl + "pay", onlineOrderData)
                                    .then(async (response) => {
                                        if (!cashfreeRef.current) {
                                            console.error("Cashfree SDK not initialized");
                                            return;
                                        }
            
                                        let checkoutOptions = {
                                            paymentSessionId: response.data.payment_session_id,
                                            redirectTarget: "_modal",
                                        };
                                        
                                        cashfreeRef.current.checkout(checkoutOptions).then(async (result) => {
                                            if (result.error) {
                                                console.error("error while doing payment");
                                                if (result.error.code !== "payment_aborted") {
                                                    await handlePaymentError(
                                                        newOrderId,
                                                        orderOrginalId,
                                                        result.error.message,
                                                        selectedPayment
                                                    );
                                                }
                                            } else if (result.paymentDetails) {
                                                // console.log("payment successful");
                                                await handlePaymentSuccess(
                                                    orderOrginalId,
                                                    newOrderId,
                                                    amount,
                                                    result.paymentDetails.paymentMessage,
                                                    selectedPayment
                                                );
                                            }
                                            setLoadingO(false)
                                        });
                                        localStorage.setItem("OrginalOrderId",newOrderId);
                                    })
                                    .catch((error) => {console.log(error)
                                        setLoadingO(false)
                                    });
                            }else {
                                            const errorData = await response.json();
                                            const errorMessage = errorData?.error || "Something went wrong";
                                            toast.error(errorMessage);
                                        }
                                                        setLoadingO(false)
                        // setShowModal(true);
            
                        } catch (error) {
            
                                        setLoadingO(false)
            
                            console.error("Error while creating order");
                            console.error(error.message);
                        }
                    } else {
                        setShowModal(true);
                    }
                };
                useEffect(() => {
                    const fetchAddresses = async () => {
                        const token = localStorage.getItem("token");
                       if(token){ try {
                            const response = await fetch(
                                `${apiBaseUrl}customer/get-all-addresses`,
                                {
                                    method: "GET",
                                    headers: {
                                        token: token,
                                    },
                                }
                            );
                            const data = await response.json();
                            // to select the default address to show on the cart screen
                            if(data?.defaultAddress) {
                                setDefaultAddress(data?.defaultAddress);
                                setSelected(data?.defaultAddress?._id)
                                localStorage.setItem("selected-address", JSON.stringify(data?.defaultAddress));
                                localStorage.setItem("selected-email", data?.defaultAddress?.email);
                                localStorage.setItem("selected-name", data?.defaultAddress?.name);
                            }else if(data?.addresses?.length > 0){
                                setDefaultAddress(data?.addresses[0]);
                                setSelected(data?.addresses[0]?._id);
                                localStorage.setItem("selected-address", JSON.stringify(data?.addresses[0]));
                                localStorage.setItem("selected-email",data?.addresses[0]?.email);
                                localStorage.setItem("selected-name", data?.addresses[0]?.name);
                            }
                            setAddresses(data.addresses || []);
                        } catch (error) {
                            console.error("Error fetching addresses:", error);
                        }}
                    };
            
                    fetchAddresses();
                }, [token, refreshAddresses]);
                const [percentagedata, setPercentagedata] = useState({
                        shippingpercentage: "",
                        pgfeepercentage: "",
                    });

                    useEffect(() => {
                            if (storedCartItems && storedCartItems.length > 0) {
                                const filteredCartItems = storedCartItems.filter(
                                    (item) => item.storeid ===  userData?.id
                                );
                                setCartitems(filteredCartItems);
                            }else{
                                const loadCartItems = async () => {
                                    try {
                                        if (!userData?.id) {
                                            console.warn("userData?.id is undefined, waiting for user data...");
                                            return;
                                            }
                    
                            if(userData&&userData.id){  const response = await fetch(`${apiBaseUrl}cart/fetch-user-cart`, {
                                method: "POST",
                                headers: {"Content-Type": "application/json",...(token && { token: token }),},
                                body: JSON.stringify({
                                  storeid: userData?.id,
                                  customerId: customerId,
                                  cartContext: cartContext,
                                }),
                                        });
                    
                                        const data = await response.json();
                    
                                        if (data?.cart) {
                                            if(data.cart.cartItem?.length > 0){
                                                const filteredCartItems = data.cart.cartItem.filter(
                                                    (item) => item.storeid ===  userData?.id
                                                );
                                                setCartitems(filteredCartItems);
                                                //dispatch(getCartInfo(data.cart));
                                            }
                                        }}
                                    } catch (error) {
                                        console.error("Error fetching User Cart Information:", error);
                                    }
                                }
                                loadCartItems();
                            }
                        }, [userData?.id, token, customerId, cartContext, storedCartItems&&storedCartItems[0]]);
                        // }, [userData?.id, token, customerId, cartContext, storedCartItems]);
                    
                        const deleteItemFromCart = (deletedCartItem) => {
                            return new Promise(async (resolve, reject) => {
                                try {
                                    const response = await fetch(
                                        `${apiBaseUrl}cart/delete-item-from-cart`,
                                        {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                token: token,
                                            },
                                            body: JSON.stringify({
                                                storeid:  userData?.id,
                                                id: deletedCartItem?.productId,
                                                variant: deletedCartItem?.variant,
                                                cartContext: cartContext,
                                                customerId: customerId,
                                            }),
                                        }
                                    );
                                    const data = await response.json();
                                    dispatch(getCartInfo(data?.cart));
                                    if (data?.code === "CART_EMPTY") {
                                        localStorage.removeItem("cartContext");
                                    }
                                    resolve(data?.cart?.cartItem);
                                } catch (e) {
                                    console.error("error while deleting the item from cart");
                                    reject(e);
                                }
                            });
                        };
                    
                        const handleQuantityChange = (index, newQuantity) => {
                            const updatedCartItems = [...cartItems];
                            setLoading(true);
                            if (updatedCartItems) {
                                const item = updatedCartItems[index];
                                const productId = item?.productId;
                                if (productId && newQuantity) {
                                    updateProductQuantity(newQuantity, productId, item?.variant).then(
                                        (cartItem) => {
                                            if (cartItem) {
                                                setCartitems([...cartItem]);
                                            }
                                            setLoading(false);
                                        },
                                        (error) => {
                                            setLoading(false);
                                            console.error(
                                                `Error occurred while updating the item quantity in cart: ${error}`
                                            );
                                        }
                                    );
                                }
                            }
                        };
                    
                        /**
                         * This method is used to update product quantity
                         * @param quantity
                         * @param productId
                         * @param variant
                         * @returns {Promise<unknown>}
                         */
                        const updateProductQuantity = async (quantity, productId, variant) => {
                            return new Promise(async (resolve, reject) => {
                                try {
                                    let headers = {
                                        "Content-Type": "application/json",
                                    };
                                    if (token) {
                                        headers["token"] = token;
                                    }
                                    const response = await fetch(
                                        `${apiBaseUrl}cart/update-item-quantity-in-cart`,
                                        {
                                            method: "POST",
                                            headers: headers,
                                            body: JSON.stringify({
                                                storeid:  userData?.id,
                                                id: productId,
                                                quantity: quantity,
                                                variant: variant,
                                                cartContext: cartContext,
                                                customerId: customerId,
                                            }),
                                        }
                                    );
                                    const data = await response.json();
                                    dispatch(getCartInfo(data?.cart));
                                    resolve(data?.cart?.cartItem);
                                } catch (e) {
                                    console.error("error while updating the quantity of product");
                                    reject(e);
                                }
                            });
                        };
                    
                        const calculateTotal = () => {
                            let totalCartValue = cartItems.reduce((total, item) => {
                                const itemQuantity = item.quantity || 1;
                                const itemTotal = (item.price===0 ? item.mrp : item.price) * itemQuantity;
                                // console.log(
                                //     `Item: ${item.title}, Price: ${item.price}, Quantity: ${itemQuantity}, Item Total: ${itemTotal}`
                                // );
                                return total + itemTotal;
                            }, 0);
                    
                            // console.log(`Total Cart Value: ${totalCartValue}`);
                    
                            const shippingCharges =
                                cartItems.length === 0
                                    ? 0
                                    : shippingfeestatus === 1
                                    ? shippingfee
                                    : percentagedata.shippingpercentage;
                            // console.log(`Shipping Charges: ${shippingCharges}`);
                    
                            const paymentGatewayCharges =
                                cartItems.length === 0
                                    ? 0
                                    : pgfeestatus === 1
                                    ? pgfee
                                    : percentagedata.pgfeepercentage;
                            // console.log(`Payment Gateway Charges: ${paymentGatewayCharges}`);
                    
                            const couponDiscount = currentCoupon !== "" ? 10 : 0;
                            // console.log(`Coupon Discount: ${couponDiscount}`);
                    
                            const total =
                                Number(totalCartValue) +
                                Number(shippingCharges) +
                                Number(paymentGatewayCharges) -
                                Number(couponDiscount);
                            // console.log(`Total: ${total}`);
                    
                            return total;
                        };
                    
                    
                        const calculateTotalMrp = () => {
                            let totalCartValue = cartItems.reduce((total, item) => {
                                const itemQuantity = item.quantity || 1;
                                let itemTotal = 0;
                                if(item?.variant?.variant4?.title){
                                    itemTotal = item?.variant?.variant4?.title * itemQuantity;
                                    // console.log(
                                    //     `Item: ${item.title}, Price: ${item?.variant?.variant4?.title}, Quantity: ${itemQuantity}, Item Total: ${itemTotal}`
                                    // );
                                }
                                return total + itemTotal;
                            }, 0);
                    
                            // console.log(`Total Cart Value: ${totalCartValue}`);
                    
                            const shippingCharges =
                                cartItems.length === 0
                                    ? 0
                                    : shippingfeestatus === 1
                                    ? shippingfee
                                    : percentagedata.shippingpercentage;
                            // console.log(`Shipping Charges: ${shippingCharges}`);
                    
                            const paymentGatewayCharges =
                                cartItems.length === 0
                                    ? 0
                                    : pgfeestatus === 1
                                    ? pgfee
                                    : percentagedata.pgfeepercentage;
                            // console.log(`Payment Gateway Charges: ${paymentGatewayCharges}`);
                    
                            const couponDiscount = currentCoupon !== "" ? 10 : 0;
                            // console.log(`Coupon Discount: ${couponDiscount}`);
                    
                            const total =
                                Number(totalCartValue) +
                                Number(shippingCharges) +
                                Number(paymentGatewayCharges) -
                                Number(couponDiscount);
                            // console.log(`Total: ${total}`);
                    
                            return total;
                        };
                    
                    
                        const totalAmountOfProduct = calculateTotal();
                        const totalMrpOfProduct = calculateTotalMrp();
                        const couponDiscountAmount = currentCoupon ? 10 : 0;
                        const shippingCharges =
                            cartItems.length === 0
                                ? 0
                                : shippingfeestatus === 1
                                ? shippingfee
                                : percentagedata.shippingpercentage;
                        const paymentGatewayCharges =
                            cartItems.length === 0
                                ? 0
                                : pgfeestatus === 1
                                ? pgfee
                                : percentagedata.pgfeepercentage;
                        const totalShippingAndPayment =
                            Number(shippingCharges) + Number(paymentGatewayCharges);
                        const totalqtyprice = Number(totalAmountOfProduct) - totalShippingAndPayment;
                        const totalMrpPrice = Number(totalMrpOfProduct) - totalShippingAndPayment;
                    
                        // shipping fee
                        useEffect(() => {
                            const fetchShippingFee = async () => {
                    
                                if(token){
                                try {
                                    const response = await fetch(
                                        `${apiBaseUrl}lFee/getLogisticsFee/`,
                                        {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                token: token,
                                            },
                                            body: JSON.stringify({userId:  userData?.id}),
                                        }
                                    );
                    
                                    const data = await response.json();
                                    const shippingFeePercentage = Number(shippingfee) / 100;
                                    const totalAmountAfterShipping = Number(totalqtyprice);
                                    const calculatedValue =
                                        shippingFeePercentage * totalAmountAfterShipping;
                                    const roundedValue = Math.ceil(calculatedValue);
                                    setshippingfeelivestatus(data?.data?.status);
                                    if (shippingfeelivestatus === 1) {
                                        setShippingfee(data.data?.feeValue);
                                    } else if (shippingfeelivestatus === 0) {
                                        setShippingfee(0);
                                    }
                                    setshippingfeestatus(data?.data?.type);
                                    setPercentagedata((prevState) => ({
                                        ...prevState,
                                        shippingpercentage: roundedValue,
                                    }));
                                } catch (err) {
                                    console.error("Error fetching logistics fee:", err);
                                }}
                            };
                    
                            fetchShippingFee();
                        }, [ userData?.id, token, totalqtyprice, shippingfee, shippingfeelivestatus]);
                    
                        // Pg Fee
                        useEffect(() => {
                            const fetchPgFee = async () => {
                                try {
                                    const response = await fetch(
                                        `${apiBaseUrl}pFee/getPgFee/`,
                                        {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                token: token,
                                            },
                                            body: JSON.stringify({userId:  userData?.id}),
                                        }
                                    );
                    
                                    const data = await response.json();
                                    const calculatedValue = (pgfee / 100) * totalqtyprice;
                                    const roundedValue = Math.ceil(calculatedValue);
                                    setpgfeelivestatus(data.data?.status);
                                    if (pgfeelivestatus === 1) {
                                        setPgfee(data.data?.feeValue);
                                    } else if (pgfeelivestatus === 0) {
                                        setPgfee(0);
                                    }
                                    setpgfeestatus(data?.data?.type);
                                    setPercentagedata((prevState) => ({
                                        ...prevState,
                                        pgfeepercentage: roundedValue,
                                    }));
                                } catch (err) {
                                    console.error("Error fetching logistics fee:", err);
                                }
                            };
                    
                            fetchPgFee();
                        }, [ userData?.id, token, totalqtyprice, pgfee, pgfeelivestatus]);
                    
                        // const handelprocesstobuy = () => {
                        //     if (token) {
                        //         localStorage.setItem("discountamt", couponDiscountAmount);
                        //     } else {
                        //         navigate(isPredefinedDomain ? `/${uid}/login` : "/login", {state: {isComeFromCheckout:true}});
                        //     }
                        // };
                    
                    
                        const [isExpanded, setIsExpanded] = useState(true);
                        const [modalOpen, setModalOpen] = useState(false);
                        const [appliedCoupon, setAppliedCoupon] = useState(null);
                        const [coupons, setCoupons] = useState([]);
                        const [isAddressModalOpen, setAddressModalOpen] = useState(false);
                        const [selectedPayment, setSelectedPayment] = useState(""); 
                    
                        useEffect(() => {
                            const fetchAddresses = async () => {
                                try {
                                    const response = await fetch(`${apiBaseUrl}customer/get-all-addresses`, {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "token": token,
                                        },
                                    });
                                    const data = await response.json();
                                    // console.log("default Address 2")
                                    // console.log(data?.defaultAddress)
                                    //setDefaultAddress(data?.defaultAddress);
                                    setAddresses(data?.addresses);
                                } catch (error) {
                                    console.error("Error fetching addresses:", error);
                                }
                            };
                    
                            fetchAddresses();
                        }, [setRefreshAddresses]);
                    
                        const delcartitem = (index) => {
                            const deletedCartItem = cartItems.filter((_, i) => i === index);
                            if (deletedCartItem && deletedCartItem.length > 0) {
                                setIsLoading(true);
                                deleteItemFromCart(deletedCartItem[0]).then(
                                    (cartItem) => {
                                        if (cartItem) {
                                            setCartitems([...cartItem]);
                                        }
                                        window.location.reload()
                                        setIsLoading(false);
                                    },
                                    (error) => {
                                                            window.location.reload()
                    
                                        setIsLoading(false);
                                        console.error(`error while deleting the item from cart : ${error}`);
                                    }
                                );
                            }
                        };
                    
                        const [loginstatus, setLoginstatus] = useState();
                        const [values, setValues] = useState(['', '', '', '']);
                        const inputRefs = useRef([]);
                        const [timer, setTimer] = useState(300);
                        const [loading, setLoading] = useState(false);
                    
                        const [errorMessage, setErrorMessage] = useState('');
                        const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
                    
                        const formatTimer = (time) => {
                            const minutes = String(Math.floor(time / 60)).padStart(2, '0');
                            const seconds = String(time % 60).padStart(2, '0');
                            return `${minutes}:${seconds} Sec`;
                        };
                    
                        const handleOtpInputChange = useCallback((index, e) => {
                            const value = e.target.value;
                            if (value.length <= 1 && /^[0-9]*$/.test(value)) {
                                const newValues = [...values];
                                newValues[index] = value;
                                setValues(newValues);
                    
                                if (value && index < inputRefs.current.length - 1) {
                                    inputRefs.current[index + 1].focus();
                                } else if (!value && index > 0) {
                                    inputRefs.current[index - 1].focus();
                                }
                            }
                        }, [values]);
                    
                        const handleInputChange = (event) => {
                            setMobileNumber(event.target.value);
                            if (error) setError('');
                        };
                    
                        // const handleButtonClick = async (e) => {
                        //     e.preventDefault();
                        //     if (mobileNumber.length !== 10 || !/^\d{10}$/.test(mobileNumber)) {
                        //         setError('Please enter a valid 10-digit number');
                        //         return;
                        //     }
                    
                        //     const apiUrl = `${apiBaseUrl}customer/login`;
                        //     const payload = {
                        //         mobile: `91${mobileNumber}`
                        //     };
                    
                        //     try {
                        //         const response = await fetch(apiUrl, {
                        //             method: "POST",
                        //             headers: {
                        //                 "Content-Type": "application/json"
                        //             },
                        //             body: JSON.stringify(payload)
                        //         });
                    
                        //         const result = await response.json();
                    
                        //         if (response.ok) {
                        //             setCartLoginRequired(false);
                        //             setOtpVerificationRequired(true)
                        //         } else {
                        //             console.error("Error sending OTP:", result);
                        //         }
                        //     } catch (error) {
                        //         console.error("Error:", error);
                        //     }
                        // };
                    
                        useEffect(() => {
                            if (mobileNumber) {
                                const url = `${apiBaseUrl}customer/customer-status`;
                    
                                fetch(url, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        "mobile": mobileNumber
                                    })
                                })
                                    .then(response => response.json())
                                    .then(data => {
                                        setLoginstatus(data?.status);
                                    })
                                    .catch(error => {
                                        console.error("Error:", error);
                                    });
                            }
                        }, [mobileNumber]);
                    
                        const handleResendClick = useCallback(() => {
                            setTimer(300);
                        }, []);
                    
                        const handleVerifyClick = useCallback(async (e) => {
                            e.preventDefault();
                            setLoading(true)
                            if (loginstatus === 0 && !isCheckboxChecked) {
                                setErrorMessage("Please agree to the Terms and Conditions.");
                                setLoading(false);
                                return;
                            }
                    
                            const otp = values.join('');
                            try {
                                const response = await fetch(`${apiBaseUrl}customer/otp-verify`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        "user_number": mobileNumber,
                                        "otp": Number(otp),
                                        "cartContext": cartContext
                                    })
                                });
                                const data = await response.json();
                                dispatch(getUserInfo(data?.user))
                                if (response.ok) {
                                    localStorage.setItem('token', data?.token);
                                    localStorage.setItem('usermob', data?.user?.phone);
                                    localStorage.setItem('customerId', data?.user?._id)
                                    localStorage.removeItem("cartContext");
                                    if (data?.token) {
                                        setLoading(true)
                                        await fetchUserCartInfo( userData?.id, data.token, data?.user?._id)
                                            .then((data) => {
                                                if (data?.cart?.cartItem?.length > 0) {
                                                    setOtpVerificationRequired(false);
                                                    setRefreshAddresses(true);
                                                } else {
                                                   navigate(isPredefinedDomain ? `/${uid}`:"/");
                                                }
                                            })
                                            .catch((error) => {
                                                setLoading(false);
                                                console.error(
                                                    `Error occurred while fetch the user cart ${error}`
                                                );
                                            });
                                    } else {
                                        setLoading(false)
                                        navigate(isPredefinedDomain ? `/${uid}`:"/");
                                    }
                                } else {
                                    setErrorMessage(data.message || "Verification failed. Please try again.");
                                    setLoading(false)
                                }
                            } catch (error) {
                                setErrorMessage("An error occurred. Please try again later.");
                                setLoading(false)
                            }
                        }, [values, mobileNumber, navigate,  userData?.id, loginstatus, isCheckboxChecked]);
                    
                        /**
                         * This method is sued to fetch user cart information once user is logged in
                         * @param storeId
                         * @param token
                         * @param customerId
                         * @returns {Promise<unknown>}
                         */
                        const fetchUserCartInfo = (storeId, token, customerId) => {
                            return new Promise(async (resolve, reject) => {
                                if (token) {
                                    try {
                                        const response = await fetch(
                                            `${apiBaseUrl}cart/fetch-user-cart`, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "token": token
                                                },
                                                body: JSON.stringify({
                                                    "storeid": storeId,
                                                    "customerId": customerId
                                                })
                                            }
                                        );
                                        const data = await response.json();
                                        dispatch(getCartInfo(data?.cart));
                                        resolve(data);
                                    } catch (e) {
                                        console.error("error while fetch user cart information")
                                        reject(e);
                                    }
                                }
                            });
                        }
                    
                        useEffect(() => {
                            const intervalId = setInterval(() => {
                                setTimer(prevTimer => {
                                    if (prevTimer <= 0) {
                                        clearInterval(intervalId);
                                        return 0;
                                    }
                                    return prevTimer - 1;
                                });
                            }, 1000);
                    
                            return () => clearInterval(intervalId);
                        }, []);
                    
                        // fetch cart discounts 
                        useEffect(() => {
                            const fetchCartDiscounts = async () => {
                                try {
                                    const response = await fetch(
                                        `${apiBaseUrl}discount/cart-discounts`,
                                        {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                // token: token,
                                            },
                                            body: JSON.stringify({
                                                storeid:  userData?.id,
                                                customerId: customerId,
                                                cartItems: cartItems,
                                            }),
                                        }
                                    );
                                    const data = await response.json();
                                    // console.log("🚀 ~ fetchCartDiscounts ~ data:", data)
                                    setCoupons(data?.data || []);
                                } catch (error) {
                                    console.error("Error fetching coupons:", error);
                                }
                            };
                    
                            if(userData&&userData.id){
                            fetchCartDiscounts();}
                        }, [ userData?.id, customerId, cartItems]);










const [addressType, setAddressType] = useState('addAddress');
const [showEditAddressForm, setShowEditAddressForm] = useState(false);
    const [showAddAddressForm, setShowAddAddressForm] = useState(false);
    const toggleAddressForm = () => {
        setAddressType('addAddress');
        setShowEditAddressForm(false);
  setShowAddAddressForm(prev => !prev);
};

// console.log('cartItems' ,cartItems)
// console.log('addresses',addresses)  

const handelimgClick = () => {
    // navigate(
    //   isPredefinedDomain
    //     ? `/${uid}/productdetails/${productName.replace(/\s+/g, "_")}`
    //     : `/productdetails/${productName.replace(/\s+/g, "_")}`, {state : {productId:id}}
    // );
  };

 const [selectedAddressId, setSelectedAddressId] = useState("") 

 const editAddress = (item)=>{
    setShowAddAddressForm(true);
    setAddressType('editAddress')
    setSelectedAddressId(item?._id);
 }

 const [showConfirmAddress, setShowConfirmAddress] = useState(false);
 const [deleteAddressId, setDeleteAddressId] = useState();
const deleteAddress = async (item)=>{

    setShowConfirmAddress(false);

        const apiUrl = `${apiBaseUrl}customer/delete-address/${item?._id}`;
        console.log(item);
        // alert('delete');

        try {
            const response = await fetch(apiUrl, {
               method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "token": token
                }
            });

            const result = await response.json();

            if (response.ok) {
                setLoading(false)
                setRefreshAddresses(prev => !prev);

            } else {
                setLoading(false)
                console.error("Error add addressing:", result);
            }
        } catch (error) {
            setLoading(false)
            console.error("Error:", error);
        }
    }


//   console.log('cartItems',cartItems);
    // console.log('storedCartItems',storedCartItems);

   
    const handleDefaultAddress = async (item) => {
        setLoading(true);
        const apiUrl = `${process.env.REACT_APP_BACKEND_URL}customer/mark-as-default/${item?._id}`;
        try {
            const response = await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "token": token
                }
            });

            const result = await response.json();

            if (response.ok) {
                setLoading(false)
                setRefreshAddresses(prev => !prev);
                // window.location.reload(); // Auto reload after setting as default
            } else {
                setLoading(false)
                console.error("Error add addressing:", result);
            }
        } catch (error) {
            setLoading(false)
            console.error("Error:", error);
        }
    }
  
    const [selfDefaultAddress,setSetSelfDefaultAddress] = useState(false);
    const [selfDefaultAddressVal,setSelfDefaultAddressVal] = useState();

    useEffect(()=>{
if(selfDefaultAddress){
    console.log('selfDefaultAddressVal',selfDefaultAddressVal)
handleDefaultAddress(selfDefaultAddressVal)
}
    },[0])

  return (
    <>
    <ProfileHeaderSlider />
    <HeaderSlider />
    <HeaderMainNavigation />
    {loading && <Loader/>}
    <section className="cart2-section">
        <div className="container">
            <div className="mainHeadingBox"><h1 className="mainHeading text-center">Cart</h1></div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="cart-card card-box">
                        <div className="cart-heading"><h3 className="h3 heading">Your Cart ({cartItems?.length} item{cartItems.length > 1?'s':''})</h3></div>
                        <div className="cart-box">
                            {cartItems.length > 0 && !isLoading ? (
                                   
                                   
                              cartItems.length>0?     <>
                                        {cartItems.map((item, index) => (
                            <SingleCartProductNew
                                                key={index}
                                                src={item.image}
                                                id={item.productId}
                                                variantname={"Variant"}
                                                value={
                                                    item?.variant?.firstVariant?.title?.value &&
                                                    item?.variant?.secondVariant?.title?.value
                                                      ? `${item?.variant?.firstVariant?.title?.value.split("||")[0].trim()} / ${item?.variant?.secondVariant?.title?.value.split("||")[0].trim()}`
                                                      : item?.variant?.firstVariant?.title?.value?.split("||")[0].trim() ||
                                                        item?.variant?.secondVariant?.title?.value?.split("||")[0].trim() ||
                                                        null
                                                }
                                                productName={item.title}
                                                price={item.price}
                                                mrp={item?.mrp}
                                                newquantity={item.quantity}
                                                itemIndex={index}
                                                delcartitem={delcartitem}
                                                onQuantityChange={handleQuantityChange}
                                                stock={
                                                    item.stock
                                                  }
                                            />
                            ))}
                                    </>
:null
                                ) : (
                                    !isLoading && (
                                        <div className="cart-empty">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="50px"
                                                height="50px"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    style={{fill: "#3371a5"}}
                                                    d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm1.336-5l1.977-7h-16.813l2.938 7h11.898zm4.969-10l-3.432 12h-12.597l.839 2h13.239l3.474-12h1.929l.743-2h-4.195z"
                                                />
                                            </svg>
                                            <p>Cart is empty</p>
                                        </div>
                                    )
                                )}
                                {isLoading && (
                                    <div className="cart-loading">
                                        <p>Loading...</p>
                                    </div>
                                )}
                        </div>
                        {/* <div className="offter-box">
                            <FaCheckCircle /> <span>Free shipping applied on orders over ₹999</span>
                        </div> */}
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card-box cart-order-summary">
                        <div className="cart-heading"><h3 className="h3 heading heading-light">Order Summary</h3></div>
                        <ul className="cart-order-list">
                            <li><span>Subtotal ({cartItems.reduce((total, item) => total + (item.quantity || 1), 0)} item{cartItems.length > 1?'s':''})</span> <span>{totalqtyprice.toLocaleString('en-US', {style: 'currency',currency: 'INR',})}</span></li>
                            <li><span>Shipping</span> <span>{shippingCharges.toLocaleString('en-US', {style: 'currency',currency: 'INR',})}</span></li>
                            {/* <li><span>Tax</span> <span>₹360</span></li> */}
                            <li><span>Discount({currentCoupon})</span> <span>{couponDiscountAmount.toLocaleString('en-US', {style: 'currency',currency: 'INR',})}</span></li>
                            <li><b>Total</b> <b>{totalAmountOfProduct.toLocaleString('en-US', {style: 'currency',currency: 'INR',})}</b></li>
                        </ul>
                    </div>
                    <PaymentMethodsNew selectedPayment={selectedPayment} setSelectedPayment={setSelectedPayment}/>
                    
                    <div className="cart-address-box card-box">
                        <div className="cart-heading"><h3 className="h3 heading heading-light">Delivery Address</h3> <div className="toggleBtnBox" onClick={toggleAddressForm}><span>{showAddAddressForm ? 'Show Address List' : 'Add New Address'}</span></div></div>
                        <div className={`addAddressFormBox ${showAddAddressForm ? 'slide-down' : 'slide-up'}`} sx={{display:'none'}}>
                            {addressType =='editAddress'?<EditAddressNew setRefreshAddresses={setRefreshAddresses} addressId={selectedAddressId}  setShowAddAddressForm={setShowAddAddressForm} />:<AddAddressNew  setRefreshAddresses={setRefreshAddresses}  setShowAddAddressForm={setShowAddAddressForm} />}
                            
                        </div>
                        <div className={`address-list-wrapper  ${showAddAddressForm ? 'slide-up' : 'slide-down'}`}>
                            <ul className="list">
                                <ConfirmationDialog show={showConfirmAddress} onClose={() => setShowConfirmAddress(false)} onConfirm={()=>{deleteAddress(deleteAddressId)}} confirmationMessage="Do you want to remove this address ?" />
                                {
                                    addresses && addresses.toReversed().map((item,index)=>{
                                        // if(addresses.length === 1){setSetSelfDefaultAddress(true);setSelfDefaultAddressVal(item)}
                                        return(
                                <li key={index} className={`radio-icon-box ${item.defaultAddress || addresses.length === 1 ?  'selected-item':null}`}>
                                    <div className="icon-box" onClick={()=> handleDefaultAddress(item)}
                                    ><FaCircle/></div>
                                    <div className="address-list-box">
                                        <h6 className="h6 name">{item.name}
                                            <div className="btnRow">
                                                <div className="link editBtn"   onClick={() => editAddress(item)}><FaPencilAlt/> <span> Edit</span></div> | 
                                                <div className="link removeBtn"  onClick={() => {
                                                    setDeleteAddressId(item);
                                                    setShowConfirmAddress(true);

                                                }}><FaTrash/> <span> Remove</span></div>
                                            </div>
                                        </h6>
                                        <p>{item.addressLine1}, {item.addressLine2}, {item.district} <br />
                                        {item.state}, {item.country}-{item.zip} <br />
                                        <b>Mobile: </b> {item.countryCode} {item.mobile} <br />
                                        <b>Email: </b> {item.email}</p>
                                    </div>
                                </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="btnBox">
                        <Button className="button theme-btn" onClick={() => {
                                placeOrder();
                            }}
                            disabled={!selected && isCartItemUpdated ||loadingO||!selected||cartItems.length===0}>{loadingO?"Processing":"Buy Now"}</Button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Footer />
    </>
  )
}
